(function () {
  // ── Accordion: single open at a time, CSS animates max-height ──
  function closeAll(scope) {
    scope.querySelectorAll('.faq-custom__item').forEach(function (item) {
      item.classList.remove('active', 'is-open');
      var q = item.querySelector('.faq-custom__question');
      if (q) q.setAttribute('aria-expanded', 'false');
      var ans = item.querySelector('.faq-custom__answer');
      if (ans) ans.style.maxHeight = null;
    });
  }

  document.addEventListener('click', function (e) {
    var question = e.target.closest('.faq-custom__question');
    if (!question) return;

    var item = question.closest('.faq-custom__item');
    if (!item) return;

    var scope = item.closest('.faq-custom') || document;
    var answer = item.querySelector('.faq-custom__answer');
    var wasOpen = item.classList.contains('active');

    closeAll(scope);

    if (!wasOpen) {
      item.classList.add('active', 'is-open');
      question.setAttribute('aria-expanded', 'true');
      if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  });

  // ── GSAP scroll-in (heading / list / image fade-up) ──
  function initScrollIn(root) {
    if (!window.gsap) return;
    (root || document).querySelectorAll('.faq-custom').forEach(function (section) {
      if (section.dataset.faqScrollInit === 'true') return;
      section.dataset.faqScrollInit = 'true';

      var targets = section.querySelectorAll(
        '.faq-custom__heading, .faq-custom__item, .faq-custom__media'
      );
      if (!targets.length) return;

      window.gsap.set(targets, { autoAlpha: 0, y: 30 });

      var reveal = function () {
        window.gsap.to(targets, {
          autoAlpha: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
        });
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal();
                obs.disconnect();
              }
            });
          },
          { threshold: 0.15 }
        );
        io.observe(section);
      } else {
        reveal();
      }
    });
  }

  function init() {
    initScrollIn();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initScrollIn(e.target);
  });
})();
